.graphql-field-enum {
    /* Overrides the parent font-size so the select-picker is 14px */
    font-size: 14px;
}
